export default {
  columns: {
    title: 'Titel',
    image: 'Afbeelding',
    button_url: 'Knop-URL',
    button_text: 'Knoptekst',
    description: 'Beschrijving',
    visible: 'Zichtbaar',
    actions: 'Acties',
  },
  buttons: {
    create_post: 'Bericht aanmaken',
    edit: 'Bewerken',
    delete: 'Verwijderen',
    cancel: 'Annuleren',
    confirm: 'Bevestigen',
  },
  title: 'Uitgelichte berichten',
  delete_confirmation: 'Weet je zeker dat je dit bericht wilt verwijderen?',
};
